// Constants
export const precios = () => {
  return {
    precios: {
      id: {
        namepath: [],
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        datatype: 
        {
          predeterminate: ''
        }
      },
      id_datos_contacto: {
        type: "text",
        label: "Contacto",
        placeholder: "",
        namepath: ['admin_precios','configuracion'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "datos_contacto",
          label: 'name'
        }
      }, 
      id_list_riesgo: {
        type: "text",
        label: "Contacto",
        placeholder: "",
        namepath: ['admin_precios'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "list_riesgo",
          label: 'name'
        }
      },
      exonerado: {
        namepath: ['admin_precios'],
        type: 'boolean',
        label: 'Exonerado Parafiscales',
        placeholder: '',
        description: 'exonerado',
        validate: '',
        datatype: 
        {
          type: 'check',
          disabled: false,
          predeterminate: 0,
        }
      },
      afleps: {
        namepath: ['admin_precios'],
        type: 'number',
        label: 'Afiliación EPS',
        placeholder: '',
        description: 'Afl EPS',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      aflccf: {
        namepath: ['admin_precios'],
        type: 'number',
        label: 'Afiliación CCF',
        placeholder: '',
        description: 'Afl CCF',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 10,
          prepend: '$',
          append: '',
        }
      },
      aflafp: {
        namepath: ['admin_precios'],
        type: 'number',
        label: 'Afiliación AFP',
        placeholder: '',
        description: 'Afl AFP',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      epsarl: {
        namepath: ['admin_precios'],
        type: 'number',
        label: 'Admin',
        placeholder: '',
        description: 'Admin EPS+ARL',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      apsarlccf: {
        namepath: ['admin_precios'],
        type: 'number',
        label: 'Admin',
        placeholder: '',
        description: 'Admin EPS+ARL+CCF',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      epsarlafp: {
        namepath: ['admin_precios'],
        type: 'number',
        label: 'Admin',
        placeholder: '',
        description: 'Admin EPS+ARL+AFP',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      epsarlccfafp: {
        namepath: ['admin_precios'],
        type: 'number',
        label: 'Admin',
        placeholder: '',
        description: 'Admin EPS+ARL+CCF+AFP',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
    }
  }
}
